import { Grid } from "@mui/material";
import CardBox from "../../../../main/components/CardBox";
import ParetoReportChart from "./ParetoReportChart";
import { ParetoChartValues } from "../../../dashboard/components/ParetoChart";
import { ParetoDeOcorrenciasNoMes } from "../../types";
import { useContext } from "react";
import { MainContext } from "../../../../main/context/MainContextProvider";

export default function GeneratedParetoCharts() {
  const { relatorioMensal } = useContext(MainContext);

  const ugsPareto = [
    ...new Set(
      relatorioMensal?.paretoDeOcorrenciasNoMesByArea.alarms.map(
        (item) => item.name
      )
    ),
  ];

  const paretoDeOcorrenciasNoMesByAreaAlarms: ParetoChartValues[][] =
    ugsPareto.map((ug) => {
      if (relatorioMensal)
        return relatorioMensal.paretoDeOcorrenciasNoMesByArea.alarms.filter(
          (item) => item.name === ug
        );
      else return [];
    });

  const paretoDeOcorrenciasNoMesByArea: ParetoDeOcorrenciasNoMes[] =
    paretoDeOcorrenciasNoMesByAreaAlarms.map((alarms, index) => {
      const totalAmount = alarms.reduce((acc, item) => acc + item.amount, 0);
      const updatedPercentageAlarms = alarms.map((item) => {
        return {
          ...item,
          percentage: (item.amount / totalAmount) * 100,
        };
      });
      return {
        type: "Pareto",
        title: ugsPareto[index] as string,
        alarms: updatedPercentageAlarms,
        totalAmount,
      };
    });

  const singleValueTitles = ["COM"];

  const paretoDeOcorrenciasNoMesByAreaChartSvg = paretoDeOcorrenciasNoMesByArea
    .filter((pareto) => !singleValueTitles.includes(pareto.title))
    .map((filteredPareto, i) => (
      <Grid sx={{ width: "100%" }} item xs={12} md={6}>
        <CardBox
          sx={{
            height: "100%",
            width: "100%",
            minHeight: "400px",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <ParetoReportChart
            key={i}
            data={filteredPareto}
            title={filteredPareto.title}
          />
        </CardBox>
      </Grid>
    ));

  return paretoDeOcorrenciasNoMesByAreaChartSvg;
}
